import { DeleteProperty } from "src/api/client-api/property/useDeleteProperty";
import { FormPropertyTopLevel } from "src/components/QuestionnaireForm/FormProperty/FormPropertyTopLevel";
import { FormPropertyProvider } from "./FormProperty/context/provider";
import { useEntityScores } from "src/context/Scores/useEntityScores";
import { useQuestionnaireFormContext } from "./context/useQuestionnaireForm";
import { SsqSsqHeadingSsqProperty } from "src/api/sure-api/ssq/useGetOneSsqVersion";
import { DimensionValue } from "src/api/client-api/olapScores/olapScoresSchema";
import { ValidationMessagesByKey } from "./FormProperty/validationTypes";
import { DataListValueOverride } from "src/api/client-api/dataListValueOverride/useGetAllDataListValueOverride";
import { PropertyUpdateHandler } from "./FormProperty/context/context";

type Props = {
    onUpdate: PropertyUpdateHandler;
    onDelete: (data: DeleteProperty) => void;
    ssqSsqHeadingSsqProperty: SsqSsqHeadingSsqProperty;
    ssqVersionStructureId?: number | null;
    changePost: () => void;

    dimensionValue: DimensionValue | undefined;
    gradeDimensionValue: DimensionValue | undefined;
    scoreUnit: string | undefined;
    validationErrors?: ValidationMessagesByKey;
    dataListValueOverrides: DataListValueOverride[] | undefined;
};
export const PropertyContainer = (props: Props) => {
    const {
        ssqSsqHeadingSsqProperty,
        ssqVersionStructureId,
        onUpdate,
        onDelete,
        changePost,
        dimensionValue,
        gradeDimensionValue,
        scoreUnit,
        validationErrors,
        dataListValueOverrides = [],
    } = props;
    const { lastSelectedVariation } = useEntityScores();
    const { elementsByPropertyId, post, ssqVersion, canEdit } = useQuestionnaireFormContext();

    const onPropertyUpdate: PropertyUpdateHandler = (data, reportOutcome) => {
        if (data.value === undefined || data.value === "") {
            data.value = "_empty_";
        }

        if (ssqVersionStructureId != null) {
            data.ssqVersionStructureId = ssqVersionStructureId;
        }

        onUpdate(data, reportOutcome);
    };

    const onPropertyDelete = (data: DeleteProperty) => {
        onDelete(data);
    };

    if (post === undefined) return null;

    // This file may be to insert inside `FormProperty` folder;
    return (
        <FormPropertyProvider
            ssqSsqHeadingSsqProperty={ssqSsqHeadingSsqProperty}
            ssqVersionStructureId={ssqVersionStructureId}
            post={post}
            elementsByPropertyId={elementsByPropertyId}
            onUpdate={onPropertyUpdate}
            onDelete={onPropertyDelete}
            allowComments={ssqVersion?.ssq.allowComments ?? true}
            score={lastSelectedVariation}
            scoreUnit={scoreUnit ?? ""}
            scoreDimension={{
                value: dimensionValue,
                grade: gradeDimensionValue,
            }}
            canEdit={canEdit}
            changePost={changePost}
            validationErrors={validationErrors}
            dataListValueOverrides={dataListValueOverrides}
        >
            <FormPropertyTopLevel
                dimensionValue={dimensionValue}
                gradeDimensionValue={gradeDimensionValue}
                validationErrors={validationErrors}
            />
        </FormPropertyProvider>
    );
};
